// extracted by mini-css-extract-plugin
module.exports = {"CatalogueWrapper":"LoyaltyCatalogue_CatalogueWrapper__26lCk"};